import { Component, OnInit, OnDestroy, ViewEncapsulation, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { DatePipe, formatDate, formatNumber } from '@angular/common';
import { Title } from "@angular/platform-browser";
import { of, from, Subscription, Subject, tap } from 'rxjs';
import { map, switchMap, concatMap, filter } from 'rxjs/operators';
import { MessageService } from 'primeng/api';

import { environment } from 'src/environments/environment';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { GraphData, DailyGraphData } from 'src/app/shared/dashboard';
import { RestApiService } from 'src/app/services/rest-api.service';

@Component({
  selector: 'app-home-chart-monthly-payments',
  templateUrl: './home-chart-monthly-payments.component.html',
  styleUrl: './home-chart-monthly-payments.component.css',
  encapsulation: ViewEncapsulation.None
})
export class HomeChartMonthlyPaymentsComponent implements OnInit, OnDestroy, OnChanges {

  today: Date = null;
  loading: boolean = true;

  globalSettinsData: GlobalSettingsData = null;

  monthSelectionOptions: any = [
    { id: 1, name: 'Результат за 6 месяцев', days: '6' },
    { id: 2, name: 'Результат c начала года', days: '12' },
    { id: 3, name: 'Результат за 12 месяцев', days: '12' },
  ];

  selectedOption: any = this.monthSelectionOptions[0];

  dataMonthlyPayments: GraphData = null;
  monthlyPayments: DailyGraphData[] = [];
  monthlyGraphOptions: any = null;

  @Input() monthPaymentsToSee: number = 6;

  @Output() onPeriodChange = new Subject<number>();   // Days to see change emitter (since today)

  monthlyPaymentsQuery: Subscription = null;

  constructor(
    private restapi: RestApiService,
    private titleService: Title,
    private messageService: MessageService,
    private globalsettingsservice: GetglobalsettingsService,
  ) {
    this.monthlyPaymentsQuery = this.onPeriodChange.pipe(
      filter(period => period > 0),
      filter(() => this.globalSettinsData != null),
      tap(() => this.loading = true),

      switchMap(period => this.restapi.getDailyPaymentsGraphData(this.globalSettinsData.mainCompanyId, this.today, this.monthPaymentsToSee, 2, this.globalSettinsData.balanceCurrencyId, 0).pipe(
        map(data => this.monthlyPayments = data),
        tap(data => environment.production || console.log('*** HomeChartMonthlyPaymentsComponent in onPeriodChange switchMap: ' + JSON.stringify(data))),
        tap(data => environment.production || console.table(data))
      ))
    ).subscribe(
      () => {
        if (this.monthlyPayments) {
          this.dataMonthlyPayments = {
            labels: [],
            datasets: [
              {
                order: 1,
                label: 'Нарастающим итогом',
                data: [],
                type: 'line',
                tension: .4,
                fill: false,
                borderColor: '#277622',
                backgroundColor: 'white',
                yAxisID: 'yaxis2'
              },

              {
                order: 2,
                label: 'Среднее',
                data: [],
                type: 'line',
                fill: false,
                borderColor: '#111111',
                backgroundColor: '#277622',
                tension: .4,
                yAxisID: 'yaxis1'
              },

              {
                order: 3,
                label: 'Оплаты помесячно',
                data: [],
                fill: false,
                backgroundColor: '#379E2F',
                yAxisID: 'yaxis1'
              },

            ],
            options: {

            }
          }

          this.monthlyPayments.forEach((element, index) => {

            this.dataMonthlyPayments.labels.push(formatDate(element.GRAFDATE, 'MM/yyyy', 'uk'/*, 'GMT+2'*/));

            let monthly = this.dataMonthlyPayments.datasets.find(ds => ds.label === 'Оплаты помесячно');
            if(monthly) monthly.data.push(element.GRAFVALUE);
            let median = this.dataMonthlyPayments.datasets.find(ds => ds.label === 'Среднее');
            if(median) median.data.push(element.MEDIUMVAL);
            let accumulated = this.dataMonthlyPayments.datasets.find(ds => ds.label === 'Нарастающим итогом');
            if(accumulated) accumulated.data.push(element.ACCUMULATED);
          });

        }
        this.loading = false;
      });
  }

  // Trigger data update on button click
  updateData() {
    this.onPeriodChange.next(this.monthPaymentsToSee);
  }

  onMonthOptionsClick(event) {
    console.log('*** HomeChartMonthlyPaymentsComponent in onMonthOptionsClick: ' + JSON.stringify(event));
    environment.production || console.log('*** HomeChartMonthlyPaymentsComponent in onMonthOptionsClick: ' + JSON.stringify(this.selectedOption));

    if (this.selectedOption) {

      switch (this.selectedOption.id) {

        default:
          this.monthPaymentsToSee = this.selectedOption.days;
          break;

        case 2: 
          this.monthPaymentsToSee = this.today.getMonth() + 1;
          break;
      }
    }

    this.onPeriodChange.next(this.monthPaymentsToSee);
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** HomeChartMonthlyPaymentsComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** HomeChartMonthlyPaymentsComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));

      switch (propName) {

        case 'monthPaymentsToSee':
          this.onPeriodChange.next(change.currentValue);
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log("*** HomeChartMonthlyPaymentsComponent ngOnDestroy")

    if (this.monthlyPaymentsQuery) { this.monthlyPaymentsQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    this.today = new Date();

    console.log('*** HomeChartMonthlyPaymentsComponent in onInit: ' + JSON.stringify(this.today));

    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    this.monthlyGraphOptions = {
      scales: {
        yaxis1: {
          axisID: 'y-axis-1',
          type: 'linear',
          display: 'auto',
          position: 'left',
          scaleBeginAtZero: true,
          ticks: {
            color: textColorSecondary,
            beginAtZero: true,
            min: 0
          },
          grid: {
            display: true,
            color: surfaceBorder
          }
        },
        yaxis2: {
          axisID: 'y-axis-2',
          type: 'linear',
          display: 'auto',
          position: 'right',
          scaleBeginAtZero: true,
          ticks: {
            color: textColorSecondary,
            beginAtZero: true,
            min: 0
          },
          grid: {
            display: false,
            color: surfaceBorder
          }
        },
      },
      tooltips: {
        enabled: true,
        mode: 'single',
        callbacks: {
          label: function (tooltipItems, data) {
            environment.production || console.log('tooltips item: ' + JSON.stringify(tooltipItems));
            return '$' + formatNumber(<number>tooltipItems.yLabel, 'uk', '1.0-0');
          }
        }
      },
    };

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();
    this.titleService.setTitle('Платежи - месячный график с усреднением и накоплением');

    this.onPeriodChange.next(this.monthPaymentsToSee);
  }

  selectData(event) {
  }
}
